RxOptions = App.loadClass 'grower::viewmodels/placement/seed_options/RxOptions'

class exports.PlantingToRxConverter
    create: (field, spp_handler, statusFn, callback) =>
        query_params =
            id: spp_handler.sppID
            layers_id: field.planting_plan_id()

        # Grab data we need from planting plan
        $.post 'backend/grower/placement/spp/convert-to-rx', query_params, (response) =>
            statusFn(response.status)
            if response.status?.type is 'success'
                @launchRx(field, spp_handler, statusFn, callback, response.data)

    launchRx: (field, spp_handler, statusFn, callback, data) =>
        # we really only care about the primary product
        brands = [
            {
                name: 'Brand 1'
                id: data.brands[0].id
                treatments_id: data.brands[0].treatments_id
            }
        ]

        if data.brands.length > 1
            # the second product is the refuge - if there are actually
            # more products than that, it means the grower did
            # something unusual and we haven't decided how to handle
            # that yet.
            brands.push {
                name: 'Refuge'
                id: data.brands[1].id
                treatments_id: data.brands[1].treatments_id
            }

        refuge = null # not sure why this is even here

        solver_variables =
            min_pop: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop')?.value)
            max_pop: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop')?.value)
            max_num_pops: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Num Pops')?.value)
            min_pop_diff: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop Diff')?.value)
            max_pop_diff: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop Diff')?.value)

        yg = spp_handler.getFieldAspectByName(field.id, 'Yield Goal')

        # Build the structure needed for Rx plan
        options =
            field: field
            year: data.year
            crop: data.crop.id
            crop_name: data.crop.name
            brands: brands
            refuge: refuge
            dual_hybrid: false
            solver_variables: solver_variables
            yield_goal: yg?.value ? null
            spp: spp_handler
            spp_id: spp_handler.sppID
            planter: data.planter
            from_state: 'grower.placement'

        rx_options = new RxOptions(options)

        # Redirect to Rx
        window.RxStorage = rx_options # The rx controller will grab this data during it's resolve
        $(window).trigger 'spp.add-planting-rx-plan' # MAJOR HAX! TODO: GET RID OF THIS!

        # Oh what hax is this!?
        spp_handler.dialog.hide()

        # Handling for when Rx is done doing it's thang
        $(window).off('rx:completed')
        $(window).on 'rx:completed', (e, data) =>
            query_params =
                id: spp_handler.sppID
                layers_id: field.planting_plan_id()

            # Clean up converted planting plan and associated records
            $.post 'backend/grower/placement/spp/rx-conversion-cleanup', query_params, (response) =>
                statusFn(response.status)

                callback(data)
